import {serverCall} from "@/redux/apis/http";
import {DASHBOARD_PROPS} from "@/app/admin/dashboard/dashboardPage";

export const checkUserPermission = async (data: any) => {
    return await serverCall({
        type: "get",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/getUserContext",
        apiDir: "api/admin/shared",
    }, null)
}

export const getUserModules = async () => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
          customQueryFile: "dashboard"
        },
        endpoint: "/getUserModules",
        apiDir: `webapi/shared`,
    }, null)
}

export const getDashboardData = async (data: DASHBOARD_PROPS) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getDashboardData",
        apiDir: `webapi/shared`,
    }, null)
}